{
  "nl": {
    "pagination": {
      "previous": "Vorige pagina",
      "next": "Volgende pagina",
      "page_report": "Pagina {page} van {total}",
      "report": "Toon {first} tot {last} van {total}",
      "total": "Totaal aantal items: {total}"
    }
  }
}